(function() {
    "use strict";

    angular.module("laekkerAI.tablet").component("kitchenApp", {
        controller: "KitchenAppController",
        templateUrl: "/components/kitchen-app/kitchen-app.html",
        bindings: {}
    });
})();
